import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { marketCouponService } from 'shared/src/api';

export const useMarketCouponList = (marketId: number) => {
  return useSuspenseQuery({
    queryKey: queryKey.marketCoupon(marketId),
    queryFn: () => marketCouponService.get(marketId),
  });
};
